import { render, staticRenderFns } from "./content-layout-footer.vue?vue&type=template&id=0aca009d"
import script from "./content-layout-footer.vue?vue&type=script&lang=js"
export * from "./content-layout-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports